import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { metrikaKeyGoalsEditorInitialState } from '../../reducers/metrikaKeyGoals';
import { ConstData, ConstMetrikaKeyGoalsData } from '../../typings/constants';
import { CurrencyCode } from '../../typings/graphql-grid';
import {
    MetrikaKeyGoalsEditorData,
    MetrikaKeyGoalsEditorState
} from '../../typings/metrikaKeyGoals';
import { State } from '../../typings/state';

export const selectMetrikaKeyGoalsEditorById = createCachedSelector(
    (state: State) => state.metrikaKeyGoalsEditor,
    (state: State, editorId: string) => editorId,
    (
        editors: MetrikaKeyGoalsEditorState,
        editorId: string
    ): MetrikaKeyGoalsEditorData => {
        return editors[editorId] || metrikaKeyGoalsEditorInitialState;
    }
)((state: State, editorId: string) => editorId);

export const selectMetrikaKeyGoalsConstants = createSelector(
    (state: State) => state.commonData.constants,
    (state: State) => state.commonData.client.workCurrency,
    (
        constants: ConstData,
        currency: CurrencyCode
    ): ConstMetrikaKeyGoalsData => {
        if (constants === undefined) {
            throw Error('No constants data');
        }

        const currencyConstants = constants.currencyConstants[currency];

        return {
            minConversion: currencyConstants.minPrice,
            maxConversion: currencyConstants.maxAutobudget
        };
    }
);
